
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from './components/Footer';
import AboutUs from './components/AboutUs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Service from './pages/Service';
import Ourfleets from './pages/Ourfleets';
import Packages from './pages/Packages';
import Booking from './pages/Booking';
// import 'react-image-lightbox/style.css';
import GalleryLightbox from './pages/GalleryLightbox';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Enquiry from './pages/Enquiry';
import Punetomumbaicab from './pages/Pune to Mumbai Cab';
import ScrollToTop from './components/ScrollToTop';
import Punetomumbaiairportcab from './pages/Pune to Mumbai Airport Cab';
import Punetomumbaiinternationalairport from './pages/Pune to Mumbai International Airport Cab';
import Punetomumbaionewaycab from './pages/Pune to Mumbai One Way Cabs';
import Punemumbaicabhire from './pages/Pune Mumbai Car Hire';
import Punetomumbaitaxifare from './pages/Pune to Mumbai Taxi Fare';
import Punetomumbaionlinecabbooking from './pages/Pune to Mumbai Online Cab Booking';
import Pimprichichwadtomumbaicab from './pages/Pimpri Chinchwad to Mumbai Cab';
import Banertomumbaicab from './pages/Baner to Mumbai Cab';
import Hinjewaditomumbaicabs from './pages/Hinjewadi to Mumbai Cab';
import Pimplessaudagartomumbaicab from './pages/Pimple Saudagar to Mumbai Cab';
import Wakadtomumbaicab from './pages/Wakad to Mumbai Cab';
import Hadapsartomumbaicab from './pages/Hadapsar to Mumbai Cab';
import Kalyaninagartomumbaitaxi from './pages/Kalyani Nagar to Mumbai Taxi';
import Koregaonparktomumbaicab from './pages/Koregaon Park to Mumbai Cab';
import Kothrudtomumbaicab from './pages/Kothrud to Mumbai Cab';
import Kharaditomumbaicab from './pages/Kharadi to Mumbai Cab';
import Shivajinagartomumbaicab from './pages/Shivajinagar to Mumbai Cab';
import Punetomumbaiertigacab from './pages/Pune to Mumbai Ertiga Cab';
import Punetomumbaiinnovacrystacab from './pages/Pune to Mumbai Innova Crysta Cab';
import Punetomumbaisedancab from './pages/Pune to Mumbai Sedan Cab';
import KKondhwatomumbaicab from './pages/Kondhwa to Mumbai Cab';
import Vimannagartomumbaicab from './pages/Viman Nagar to Mumbai Cab';
import Katrajtomumbaicab from './pages/Katraj to Mumbai Cab';
import Punestationtomumbaicab from './pages/Pune Station to Mumbai Cab';
import Boatclubroadtomumbaicab from './pages/Boat Club Road to Mumbai Cab';
import Vishrantwaditomumbai from './pages/Vishrantwadi to Mumbai Cab';
import Alanditomumbaicab from './pages/Alandi to Mumbai Cab';
import Wagholitomumbaicab from './pages/Wagholi to Mumbai Cab';
import Mumbaitopunecab from './pages/Mumbai to Pune Cab';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cab';
import Dadartopunecab from './pages/Dadar to Pune Cab';
import Mumbaitopuneonewaycab from './pages/Mumbai to Pune One Way Cab';
import Andheritopunecab from './pages/Andheri to Pune Cab';
import Bandratopunecab from './pages/Bandra to Pune Cab';
import Santacruztopunecab from './pages/Santacruz to Pune Cab';
import Mumbaicentraltopunecab from './pages/Mumbai Central to Pune Cab';
import Borivalitopunecab from './pages/Borivali to Pune Cab';
import Mumbaitopimprichichwadcab from './pages/Mumbai to Pimpri Chinchwad Cab';
import Navimumbaitopunecab from './pages/Navi Mumbai to Pune Cab';
import Mumbaiairporttopunecitycab from './pages/Mumbai Airport to Pune City Cab';
import Mumbaitopunedailycab from './pages/Mumbai to Pune Daily Cab';
import Mumbaitopuneonlinecab from './pages/Mumbai to Pune Online Cab';
import Mumbaipunecabbooking from './pages/Mumbai Pune Cab Booking';
import Jogeshwaritopunecab from './pages/Jogeshwari to Pune Cab';
import Goregaontopunecab from './pages/Goregaon to Pune Cab';
import Kandivalitopunecab from './pages/Kandivali to Pune Cab';
import Vileparletopunecab from './pages/Vile Parle to Pune Cab';
import Bhanduptopunecab from './pages/Bhandup to Pune Cab';
import Ghatkopartopunecab from './pages/Ghatkopar to Pune Cab';
import Kurlatopunecab from './pages/Kurla to Pune Cab';
import Powaimumbaipunecabservice from './pages/Powai Mumbai Pune Cab Service';
import Chemburtopunecab from './pages/Chembur to Pune Cab';
import Mumbaiairportterminaltopunecab from './pages/Mumbai Airport Terminal to Pune Cab';
import Thanetopunecab from './pages/Thane to Pune Cab';
import Vikhrolitopunecab from './pages/Vikhroli to Pune Cab';
import Mumbaitopuneinnovacrysta from './pages/Mumbai to Pune Innova Crysta Cab';
import Mumbaiairporttopunertigacab from './pages/Mumbai Airport to Pune Ertiga Cab';
import Mumbaiairportcarrental from './pages/Mumbai Airport Car Rental';
import Panveltopunecab from './pages/Panvel to Pune Cab';
import Churchgatetopunecab from './pages/Churchgate to Pune Cab';
import Bycullatopunecab from './pages/Byculla to Pune Cab';
import Vashitopunecab from './pages/Vashi to Pune Cab';
import Kharghartopunecab from './pages/Kharghar to Pune Cab';
import Mankhurdtopunecab from './pages/Mankhurd to Pune Cab';
import Mumbaitopunedailycabservice from './pages/Mumbai to Pune Daily Cab Service';
import Punemumbaidaillycabservice from './pages/Pune Mumbai Daily Cab Service';
import Onewaytaximumbaitopune from './pages/One Way Taxi Mumbai to Pune';
import Innovacrystaonrentinpune from './pages/Innova Crysta on Rent in Pune';
import Ertigacabbookinginpune from './pages/Ertiga Cab Booking in Pune';
import Kiacarenceonrentinpune from './pages/Kia Carens on Rent in Pune';
import Swiftdzireonrentinpune from './pages/Swift Dzire on Rent in Pune';
import Sedancabbookinginpune from './pages/Sedan Cab Booking in Pune';
import Forceurbaniaonrentinpune from './pages/Force Urbania on Rent in Pune';
import Fortuneronrentinpune from './pages/Fortuner on Rent in Pune';
import Mumbaisarshancab from './pages/Mumbai Darshan Cab';
import Mumbaioutstationcab from './pages/Mumbai Outstation Cab';
import Mumbaitofivejyotilinga from './pages/Mumbai to 5 Jyotirlinga Cab';
import Mumbaitomahabaleshwarcab from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaitoashtavinayakdarshancab from './pages/Mumbai to Ashtavinayak Darshan Cab';
import Mumbaitobhimashankarcab from './pages/Mumbai to Bhimashankar Cab';
import Mumbaitogoacab from './pages/Mumbai to Goa Cab';
import Mumbaitokolhapurcab from './pages/Mumbai to Kolhapur Cab';
import Mumbaitokonkandarshancab from './pages/Mumbai to Konkan Darshan Cab';
import Mumbaitopanchganicab from './pages/Mumbai to Panchgani Cab';
import Mumbaitoshirdicab from './pages/Mumbai to Shirdi Cab';
import Forceurbaniaonrentinnavimumbai from './pages/Force Urbania on Rent in Navi Mumbai';
import Minibusonrentinmumbai from './pages/Mini Bus on Rent in Mumbai';
import Innovacrystaonrentinmumbai from './pages/Innova Crysta on Rent in Mumbai';
import Ertigaonrentinmumbai from './pages/Ertiga on Rent in Mumbai';
import Mumbaiairportcabservice from './pages/Mumbai Airport Cab Service';
import Kiacarenceonrentinmumbai from './pages/Kia Carens on Rent in Mumbai';
import Sevanseatercaronrentinmumbai from './pages/7 Seater Car on Rent in Mumbai';
import Mumbaicabsonlinebooking from './pages/Mumbai Cabs Online Booking';
import Thanetogoacab from './pages/Thane to Goa Cab';
import Navimumbaitogoacab from './pages/Navi Mumbai to Goa Cab';
import Mumbaiairporttonashikcab from './pages/Mumbai Airport to Nashik Cab';
import Mumbaiairporttosatarscab from './pages/Mumbai Airport to Satara Cab.';
import Mumbaiairporttomaheshwarcab from './pages/Mumbai Airport to Mahabaleshwar Cab';
import Mumbaitoaurangabadcab from './pages/Mumbai to Aurangabad Cab';
import Mumbaitonagpurcab from './pages/Mumbai to Nagpur Cab';
import Mumbaitopandharpurcab from './pages/Mumbai to Pandharpur Cab';
import Mumbaitoajantaelloratour from './pages/Mumbai to Ajanta Ellora Tour';
import Mumbaitoprayagrajcab from './pages/Mumbai to Prayagraj Cab';
import Mumbaitoayodhyacab from './pages/Mumbai to Ayodhya Cab';
import Mumbaitosolapurcab from './pages/Mumbai to Solapur Cab';
import Cheapestcabserviceinmumbai from './pages/Cheapest Cab Service in Mumbai';
import Cheapestcabserviceinnavimumbai from './pages/Cheapest Cab Service in Navi Mumbai';
import Affordablecabserviceinumbai from './pages/Affordable Cab Service in Mumbai';
import Miraroadtopunecab from './pages/Mira Road to Pune Cab';
import Dahisartopunecab from './pages/Dahisar to Pune Cab';
import Mahimtopunecab from './pages/Mahim to Pune Cab';
import Maladtopunecab from './pages/Malad to Pune Cab';
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import ContactButtons from './components/ContactButtons';
import PuneMumbaiInfo from './components/PuneMumbaiInfo';
import MumbaiPuneCabSection from './components/MumbaiPuneCabSection';

// import Lightbox from 'react-image-lightbox';
// import 'react-image-lightbox/style.css';

function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/services" element={<Service />} />
        <Route path="/our-fleet" element={<Ourfleets />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/pune-mumbai-cabs" element={<PuneMumbaiInfo />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/booking" element={<MumbaiPuneCabSection />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/Pune-to-Mumbai-Cab" element={<Punetomumbaicab />} />

<Route path="/Pune-to-Mumbai-Airport-Cab" element={<Punetomumbaiairportcab />} />
<Route path="/Pune-to-Mumbai-International-Airport-Cab" element={<Punetomumbaiinternationalairport />} />
<Route path="/Pune-to-Mumbai-One-Way-Cab" element={<Punetomumbaionewaycab />} />
<Route path="/Pune-Mumbai-Car-Hire" element={<Punemumbaicabhire />} />
<Route path="/Pune-to-Mumbai-Taxi-Fare" element={<Punetomumbaitaxifare />} />
<Route path="/Pune-to-Mumbai-Online-Cab-Booking" element={<Punetomumbaionlinecabbooking />} />
<Route path="/Pimpri-Chinchwad-to-Mumbai-Cab" element={<Pimprichichwadtomumbaicab />} />
<Route path="/Baner-to-Mumbai-Cab" element={<Banertomumbaicab />} />
<Route path="/Hinjewadi-to-Mumbai-Cab" element={<Hinjewaditomumbaicabs />} />
<Route path="/Pimple-Saudagar-to-Mumbai-Cab" element={<Pimplessaudagartomumbaicab />} />
<Route path="/Wakad-to-Mumbai-Cab" element={<Wakadtomumbaicab />} />
<Route path="/Hadapsar-to-Mumbai-Cab" element={<Hadapsartomumbaicab />} />
<Route path="/Kalyani-Nagar-to-Mumbai-Taxi" element={<Kalyaninagartomumbaitaxi />} />
<Route path="/Koregaon-Park-to-Mumbai-Cab" element={<Koregaonparktomumbaicab />} />
<Route path="/Kothrud-to-Mumbai-Cab" element={<Kothrudtomumbaicab />} />
<Route path="/Kharadi-to-Mumbai-Cab" element={<Kharaditomumbaicab />} />
<Route path="/Shivajinagar-to-Mumbai-Cab" element={<Shivajinagartomumbaicab />} />
<Route path="/Pune-to-Mumbai-Ertiga-Cab" element={<Punetomumbaiertigacab />} />
<Route path="/Pune-to-Mumbai-Innova-Crysta-Cab" element={<Punetomumbaiinnovacrystacab />} />
<Route path="/Pune-to-Mumbai-Sedan-Cab" element={<Punetomumbaisedancab />} />
<Route path="/Kondhwa-to-Mumbai-Cab" element={<KKondhwatomumbaicab />} />
<Route path="/Viman-Nagar-to-Mumbai-Cab" element={<Vimannagartomumbaicab />} />
<Route path="/Katraj-to-Mumbai-Cab" element={<Katrajtomumbaicab />} />
<Route path="/Pune-Station-to-Mumbai-Cab" element={<Punestationtomumbaicab />} />
<Route path="/Boat-Club-Road-to-Mumbai-Cab" element={<Boatclubroadtomumbaicab />} />
<Route path="/Vishrantwadi-to-Mumbai-Cab" element={<Vishrantwaditomumbai />} />
<Route path="/Alandi-to-Mumbai-Cab" element={<Alanditomumbaicab />} />
<Route path="/Wagholi-to-Mumbai-Cab" element={<Wagholitomumbaicab />} />
<Route path="/Mumbai-to-Pune-Cab" element={<Mumbaitopunecab />} />
<Route path="/Mumbai-Airport-to-Pune-Cab" element={<Mumbaiairporttopunecab />} />
<Route path="/Dadar-to-Pune-Cab" element={<Dadartopunecab />} />
<Route path="/Mumbai-to-Pune-One-Way-Cab" element={<Mumbaitopuneonewaycab />} />
<Route path="/Andheri-to-Pune-Cab" element={<Andheritopunecab />} />
<Route path="/Bandra-to-Pune-Cab" element={<Bandratopunecab />} />
<Route path="/Santacruz-to-Pune-Cab" element={<Santacruztopunecab />} />
<Route path="/Mumbai-Central-to-Pune-Cab" element={<Mumbaicentraltopunecab />} />
<Route path="/Borivali-to-Pune-Cab" element={<Borivalitopunecab />} />


<Route path="/Mumbai-to-Pimpri-Chinchwad-Cab" element={<Mumbaitopimprichichwadcab />} />
<Route path="/Navi-Mumbai-to-Pune-Cab" element={<Navimumbaitopunecab />} />
<Route path="/Mumbai-Airport-to-Pune-City-Cab" element={<Mumbaiairporttopunecitycab />} />
<Route path="/Mumbai-to-Pune-Daily-Cab" element={<Mumbaitopunedailycab />} />
<Route path="/Mumbai-to-Pune-Online-Cab" element={<Mumbaitopuneonlinecab />} />
<Route path="/Mumbai-Pune-Cab-Booking" element={<Mumbaipunecabbooking />} />
<Route path="/Jogeshwari-to-Pune-Cab" element={<Jogeshwaritopunecab />} />
<Route path="/Goregaon-to-Pune-Cab" element={<Goregaontopunecab />} />
<Route path="/Kandivali-to-Pune-Cab" element={<Kandivalitopunecab />} />
<Route path="/Vile-Parle-to-Pune-Cab" element={<Vileparletopunecab />} />
<Route path="/Bhandup-to-Pune-Cab" element={<Bhanduptopunecab />} />
<Route path="/Ghatkopar-to-Pune-Cab" element={<Ghatkopartopunecab />} />
<Route path="/Kurla-to-Pune-Cab" element={<Kurlatopunecab />} />
<Route path="/Powai-to-Pune-Cab" element={<Powaimumbaipunecabservice />} />
<Route path="/Chembur-to-Pune-Cab" element={<Chemburtopunecab />} />
<Route path="/Mumbai-Airport-Terminal-to-Pune-Cab" element={<Mumbaiairportterminaltopunecab />} />
<Route path="/Thane-to-Pune-Cab" element={<Thanetopunecab />} />
<Route path="/Vikhroli-to-Pune-Cab" element={<Vikhrolitopunecab />} />
<Route path="/Mumbai-to-Pune-Innova-Crysta-Cab" element={<Mumbaitopuneinnovacrysta />} />
<Route path="/Mumbai-Airport-to-Pune-Ertiga-Cab" element={<Mumbaiairporttopunertigacab />} />
<Route path="/Mumbai-Airport-Car-Rental" element={<Mumbaiairportcarrental />} />
<Route path="/Panvel-to-Pune-Cab" element={<Panveltopunecab />} />
<Route path="/Churchgate-to-Pune-Cab" element={<Churchgatetopunecab />} />
<Route path="/Byculla-to-Pune-Cab" element={<Bycullatopunecab />} />
<Route path="/Vashi-to-Pune-Cab" element={<Vashitopunecab />} />
<Route path="/Kharghar-to-Pune-Cab" element={<Kharghartopunecab />} />
<Route path="/Mankhurd-to-Pune-Cab" element={<Mankhurdtopunecab />} />
<Route path="/Mumbai-to-Pune-Daily-Cab-Service" element={<Mumbaitopunedailycabservice />} />
<Route path="/Pune-Mumbai-Daily-Cab-Service" element={<Punemumbaidaillycabservice />} />
<Route path="/One-Way-Taxi-Mumbai-to-Pune" element={<Onewaytaximumbaitopune />} />
<Route path="/Innova-Crysta-on-Rent-in-Pune" element={<Innovacrystaonrentinpune />} />
<Route path="/Ertiga-Cab-Booking-in-Pune" element={<Ertigacabbookinginpune />} />
<Route path="/Kia-Carens-on-Rent-in-Pune" element={<Kiacarenceonrentinpune />} />
<Route path="/Swift-Dzire-on-Rent-in-Pune" element={<Swiftdzireonrentinpune />} />
<Route path="/Sedan-Cab-Booking-in-Pune" element={<Sedancabbookinginpune />} />
<Route path="/Force-Urbania-on-Rent-in-Pune" element={<Forceurbaniaonrentinpune />} />
<Route path="/Fortuner-on-Rent-in-Pune" element={<Fortuneronrentinpune />} />
<Route path="/Mumbai-Darshan-Cab" element={<Mumbaisarshancab />} />
<Route path="/Mumbai-Outstation-Cab" element={<Mumbaioutstationcab />} />
<Route path="/Mumbai-to-5-Jyotirlinga-Cab" element={<Mumbaitofivejyotilinga />} />










<Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwarcab />} />
<Route path="/Mumbai-to-Ashtavinayak-Darshan-Cab" element={<Mumbaitoashtavinayakdarshancab />} />
<Route path="/Mumbai-to-Bhimashankar-Cab" element={<Mumbaitobhimashankarcab />} />
<Route path="/Mumbai-to-Goa-Cab" element={<Mumbaitogoacab />} />
<Route path="/Mumbai-to-Kolhapur-Cab" element={<Mumbaitokolhapurcab />} />
<Route path="/Mumbai-to-Konkan-Darshan-Cab" element={<Mumbaitokonkandarshancab />} />
<Route path="/Mumbai-to-Panchgani-Cab" element={<Mumbaitopanchganicab />} />
<Route path="/Mumbai-to-Shirdi-Cab" element={<Mumbaitoshirdicab />} />
<Route path="/Force-Urbania-on-Rent-in-Navi-Mumbai" element={<Forceurbaniaonrentinnavimumbai />} />
<Route path="/Mini-Bus-on-Rent-in-Mumbai" element={<Minibusonrentinmumbai />} />
<Route path="/Innova-Crysta-on-Rent-in-Mumbai" element={<Innovacrystaonrentinmumbai />} />
<Route path="/Ertiga-on-Rent-in-Mumbai" element={<Ertigaonrentinmumbai />} />
<Route path="/Mumbai-Airport-Cab-Service" element={<Mumbaiairportcabservice />} />
<Route path="/Kia-Carens-on-Rent-in-Mumbai" element={<Kiacarenceonrentinmumbai />} />
<Route path="/7-Seater-Car-on-Rent-in-Mumbai" element={<Sevanseatercaronrentinmumbai />} />
<Route path="/Mumbai-Cabs-Online-Booking" element={<Mumbaicabsonlinebooking />} />
<Route path="/Thane-to-Goa-Cab" element={<Thanetogoacab />} />
<Route path="/Navi-Mumbai-to-Goa-Cab" element={<Navimumbaitogoacab />} />
<Route path="/Mumbai-Airport-to-Nashik-Cab" element={<Mumbaiairporttonashikcab />} />
<Route path="/Mumbai-Airport-to-Satara-Cab" element={<Mumbaiairporttosatarscab />} />
<Route path="/Mumbai-Airport-to-Mahabaleshwar-Cab" element={<Mumbaiairporttomaheshwarcab />} />
<Route path="/Mumbai-to-Aurangabad-Cab" element={<Mumbaitoaurangabadcab />} />
<Route path="/Mumbai-to-Nagpur-Cab" element={<Mumbaitonagpurcab />} />
<Route path="/Mumbai-to-Pandharpur-Cab" element={<Mumbaitopandharpurcab />} />
<Route path="/Mumbai-to-Ajanta-Ellora-Tour" element={<Mumbaitoajantaelloratour />} />
<Route path="/Mumbai-to-Prayagraj-Cab" element={<Mumbaitoprayagrajcab />} />
<Route path="/Mumbai-to-Ayodhya-Cab" element={<Mumbaitoayodhyacab />} />
<Route path="/Mumbai-to-Solapur-Cab" element={<Mumbaitosolapurcab />} />
<Route path="/Cheapest-Cab-Service-in-Mumbai" element={<Cheapestcabserviceinmumbai />} />
<Route path="/Cheapest-Cab-Service-in-Navi-Mumbai" element={<Cheapestcabserviceinnavimumbai />} />
<Route path="/Affordable-Cab-Service-in-Mumbai" element={<Affordablecabserviceinumbai />} />
<Route path="/Mira-Road-to-Pune-Cab" element={<Miraroadtopunecab />} />
<Route path="/Dahisar-to-Pune-Cab" element={<Dahisartopunecab />} />
<Route path="/Mahim-to-Pune-Cab" element={<Mahimtopunecab />} />
<Route path="/Malad-to-Pune-Cab" element={<Maladtopunecab />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />


     </Routes>



      <Footer />
    </Router>
  );
}

export default App;
